import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";
import AlarmTagsPagedResponse from "@/types/sv-data/alarms/AlarmTagsPagedResponse";
import { EventNotification } from "@/types/sv-data/notification-rule/EventNotification";
import { EventAlarmTagRequest } from "@/types/sv-data/tags/EventAlarmTag";
import { EventAlarmTagPagedResponse } from "@/types/sv-data/tags/EventAlarmTagPagedResponse";
import { HttpStatusCode } from "@/utils/HttpStatusCode";
import { AxiosInstance } from "axios";

class EventsApi {
	private axios: AxiosInstance;
	private axiosJson: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async getAlarmTagsForEvent(eventId: number, paginatedSearchRequest?: PaginatedSearchRequest): Promise<EventAlarmTagPagedResponse> {
		const { data } = await this.axios.get(`/Event/AlarmTagsForEvent/${eventId}`, paginatedSearchRequest);
		return data;
	}

	public async getEventAlarmTagsForArea(paginatedSearchRequest?: PaginatedSearchRequest): Promise<AlarmTagsPagedResponse> {
		const { data } = await this.axios.get(`/Event/EventAlarmTagsForArea`, paginatedSearchRequest);
		return data;
	}

	public async removeEventAlarmTag(request: EventAlarmTagRequest): Promise<void> {
		await this.axiosJson.put(`/Event/RemoveEventAlarmTag`, request);
	}

	public async addEventAlarmTag(request: EventAlarmTagRequest): Promise<void> {
		await this.axiosJson.post(`/Event/AddEventAlarmTag`, request);
	}

	public async updateEventQueueItem (eventId: number, eventText: string | null, priority: number | null, overWriteText = false): Promise<void> {
		await this.axios.put(`/Event/UpdateEventQueueItem?` +
			`eventId=${eventId}` +
			(eventText ? `&eventText=${encodeURIComponent(eventText)}` : "") +
			(priority !== null ? `&priority=${priority}` : "") +
			(overWriteText ? `&overwriteText=${overWriteText}` : ""));
	}

	public async preserveEventOutcome(eventId: number, eventOutcomeId: number | null, eventOutcomeNote: string | null): Promise<void> {
		await this.axiosJson.put(`/Event/PreserveEventOutcome?` +
			`eventId=${eventId}` +
			(eventOutcomeId === null ? "" : `&eventOutcomeId=${eventOutcomeId}`) +
			(eventOutcomeNote === null ? "" : `&eventOutcomeNote=${encodeURIComponent(eventOutcomeNote)}`));
	}

	public async getSentEventNotifications(eventId: number): Promise<EventNotification[]> {
		const { data, status } = await this.axiosJson.get(`Event/GetSentEventNotifications?eventId=${eventId}`);
		if (status == HttpStatusCode.NoContent){
			return [];
		}
		return data;
	}
}

const eventsApi = new EventsApi();
export default eventsApi;
